import { init } from './site';


document.addEventListener('DOMContentLoaded', init);



// WEBPACK FOOTER //
// ./src/js/init.js